import _toConsumableArray from "D:/androidcode/zf_tms_vue/tms_vue/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { constantRoutes } from '@/router';
/* Layout */
import Layout from '@/layout';
import baseRouters from '@/router/modules/base';
var state = {
  routes: [],
  addRoutes: []
};
var mutations = {
  SET_ROUTES: function SET_ROUTES(state, routes) {
    state.addRoutes = routes;
    state.routes = constantRoutes.concat(routes);
  }
};
var actions = {
  generateRoutes: function generateRoutes(_ref, route) {
    var commit = _ref.commit;
    return new Promise(function (resolve) {
      var accessedRoutes;
      var dtRoutes = {
        path: '/',
        component: Layout,
        redirect: '/home',
        children: [].concat(_toConsumableArray(baseRouters), _toConsumableArray(route), [{
          path: '/404',
          component: function component(resolve) {
            return require(['@/views/error-page/404'], resolve);
          },
          hidden: true
        }])
      };
      accessedRoutes = [dtRoutes, {
        path: '*',
        redirect: '/404',
        hidden: true
      }];
      commit('SET_ROUTES', accessedRoutes);
      resolve(accessedRoutes);
    });
  }
};
export default {
  namespaced: true,
  //需要加上所属的模块名
  state: state,
  mutations: mutations,
  actions: actions
};